import React from "react"
import Layout from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Layout"
import SEO from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Seo"
import BodyBlocks from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BodyBlocks"
import Breadcrumbs from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Breadcrumbs"
import MicroHeroBlock from "../../../../components/blocks/MicroHeroBlock"
import TabNav from "../../../../components/modules/TabNav"

const MicrositeSubPage = ({
  content,
  name,
  subNavItems,
  parentContent,
  breadcrumbs,
  language,
}) => {
  return (
    <Layout language={language}>
      <SEO content={content} name={name} />
      <Breadcrumbs
        textColor={
          parentContent?.image?.filename?.length > 0
            ? "text-white drop-shadow"
            : "text-gray-500"
        }
        breadcrumbs={breadcrumbs}
      ></Breadcrumbs>
      <MicroHeroBlock
        block={{
          image: parentContent.image,
          kicker: parentContent.kicker,
          headline: parentContent.headline,
          subheadline: parentContent.subheadline,
          logo: parentContent.logo,
          buttons: parentContent.buttons,
        }}
      />
      <TabNav block={{ subNavItems: subNavItems }} />
      <BodyBlocks body={content.body} />
    </Layout>
  )
}

export default MicrositeSubPage
